export default {
  sm: `
  The storage, management, and utilization 
  of data in DATA CENTER GAK are all done 
  using the "eco-friendly technologies." Our 
  promise is to create the sustainable future 
  by saving energy and reducing carbon 
  dioxide emissions.
  `,
  lg: `
  The storage, management, and utilization of 
  data in DATA CENTER GAK are all done using 
  the "eco-friendly technologies." Our promise 
  is to create the sustainable future by saving 
  energy and reducing carbon dioxide 
  emissions.
  `,
  xxl: `
  The storage, management, and utilization of data in DATA 
  CENTER GAK are all done using the "eco-friendly 
  technologies." Our promise is to create the sustainable 
  future by saving energy and reducing carbon dioxide 
  emissions.
  `,
};
